import React from 'react';
import SVG from 'react-inlinesvg';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { toAbsoluteUrl } from '../AssetHelpers';
type Props = {
	className?: string;
	path: string;
	svgClassName?: string;
	height?: string;
	width?: string;
};
const KTSVG: React.FC<Props> = ({
	className = '',
	path,
	svgClassName = 'mh-50px',
	height,
	width,
}) => {
	return (
		<span
			className={`svg-icon ${className}`}
			style={{ height: height, width: width }}
		>
			<SVG
				src={toAbsoluteUrl(path)}
				className={svgClassName}
				loader={
					<SkeletonTheme
						borderRadius="6px"
						baseColor="var(--kt-gray-300)"
						highlightColor="var(--kt-light)"
					>
						<Skeleton height={height} width={width} inline={true} />
					</SkeletonTheme>
				}
			/>
		</span>
	);
};

export { KTSVG };
